import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'

import KendoDataSourceBase from '../KendoDataSourceBase'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Schema from '../KendoDataSourceBase/Schema'
import Sort from '../KendoDataSourceBase/Sort'
import Transport from '../KendoDataSourceBase/Transport'

export default {
    mixins: [
        KendoDataSourceBase,
        KendoBaseComponent,
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted () {
        this.kendoDataSource = new kendo.data.DataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.DataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSource/KendoDataSourceMixin.js